import forEach from 'lodash-es/forEach';
import set from 'lodash-es/set';
import filter from 'lodash-es/filter';
import map from 'lodash-es/map';

const ClassName = {
  BLOCK: 'app-panel',
  ANDROID: 'app-panel__android',
  IOS: 'app-panel__ios',
  CLOSE: 'app-panel__close',
  BORDER: 'app-panel__bordered',
  ROW: 'app-panel__row',
};

class AppPanel {
  constructor(elem) {
    this.block = elem;
    this.closeButton = this.block.getElementsByClassName(ClassName.CLOSE).item(0);

    // Bind functions;
    this.init = this.init.bind(this);
    this.removeAppPanel = this.removeAppPanel.bind(this);

    if (window.matchMedia(`(max-width: 992px)`).matches) {
      this.init();
    }
  }

  // Инициализация если сайт открылся на андроид/ios
  init() {
    if (/Android/i.test(navigator.userAgent)) {
      this.deviseTypeClass = ClassName.ANDROID;
      this.initPanel();
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.deviseTypeClass = ClassName.IOS;
      this.initPanel();
    }
  }

  initPanel() {
    if (!this.isElementsForDeviceExists()) return;
    this.addActiveDeviceClass();
    this.addAppPanel();
    this.addCloseButtonListener();
    this.addBottomBorder();
  }

  // Проверка на наличие элементов для активного девайса
  isElementsForDeviceExists() {
    const elementsForDevice = this.block.getElementsByClassName(this.deviseTypeClass);
    if (elementsForDevice.length) return true;
  }

  // Добавляем НЕ последнему элементу класс с бордером
  addBottomBorder() {
    const activeBlocks = document.querySelectorAll(`.${ClassName.ROW}.${this.deviseTypeClass}`);
    activeBlocks.forEach((elem, index) => {
      if (index !== activeBlocks.length - 1) elem.classList.add(ClassName.BORDER);
    });
  }

  addActiveDeviceClass() {
    this.block.classList.add(this.deviseTypeClass);
  }

  addCloseButtonListener() {
    this.closeButton.addEventListener('click', this.removeAppPanel);
  }

  removeAppPanel(event) {
    event.preventDefault();
    this.block.remove();
  }

  addAppPanel() {
    document.body.insertAdjacentElement(`afterbegin`, this.block);
  }

  static getAllBlocks() {
    return Array.from(document.getElementsByClassName(ClassName.BLOCK));
  }

  static getAllInstances() {
    return map(filter(AppPanel.getAllBlocks(), ({ins}) => ins), (item) => item.ins);
  }

  static initAllBlocks() {
    let Blocks = AppPanel.getAllBlocks();
    forEach(Blocks, (block) => {
      if (block.ins) return;
      block.ins = new AppPanel(block);
    });
  }
}

// Инициашизация;
AppPanel.initAllBlocks();

// Экспорт;
set(window, ['Block', 'AppPanel'], AppPanel);
export default AppPanel;
